import { z } from 'zod';

export const dedupeCheckSchema = z.object({
  lat: z.coerce.number().min(-90).max(90),
  lng: z.coerce.number().min(-180).max(180),
  name: z.string().trim().min(1).max(200).optional(),
  limit: z.coerce.number().int().min(1).max(10).default(5),
});

export type DedupeCheckInput = z.infer<typeof dedupeCheckSchema>;

export const dedupeCandidateSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  address: z.string().nullable(),
  city: z.string().nullable(),
  sportTypes: z.array(z.string()),
  lat: z.number(),
  lng: z.number(),
  distanceMeters: z.number(),
  nameSimilarity: z.number().nullable(),
  photoUrl: z.string().nullable(),
  rating: z.number().nullable(),
});

export type DedupeCandidate = z.infer<typeof dedupeCandidateSchema>;

export const dedupeCheckResponseSchema = z.object({
  candidates: z.array(dedupeCandidateSchema),
});

export type DedupeCheckResponse = z.infer<typeof dedupeCheckResponseSchema>;

// Returned in 409 payload when POST /api/venues hits hard-gate
export const hardDuplicateSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  distanceMeters: z.number(),
  nameSimilarity: z.number(),
});

export type HardDuplicate = z.infer<typeof hardDuplicateSchema>;
